// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".section-header__Qz67m {\n  margin-bottom: 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/pages/FormPage/Raadgivning/raadgivning.module.less"],"names":[],"mappings":"AAEA;EACI,mBAAA;AADJ","sourcesContent":["@import (reference) '~@gjensidige/core-design-tokens/lib/less/_variables.less';\n\n.section-header {\n    margin-bottom: @gje-size-spacing-2-5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section-header": "section-header__Qz67m",
	"sectionHeader": "section-header__Qz67m"
};
export default ___CSS_LOADER_EXPORT___;
